import { render, staticRenderFns } from "./RevenueManagerCompetitorForm.vue?vue&type=template&id=4457bf4c&scoped=true&"
import script from "./RevenueManagerCompetitorForm.vue?vue&type=script&lang=js&"
export * from "./RevenueManagerCompetitorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457bf4c",
  null
  
)

export default component.exports